import React from 'react';
import { loanOfficer } from '../../data/team';
import { platformName, subscriber } from '../../data/subscriber';
export function ComplianceFooter({
  className = ''
}: {
  className?: string;
}) {
  return <footer className={`mx-auto max-w-6xl px-5 py-8 text-xs leading-relaxed text-ink-400 md:px-8 ${className}`} data-id="element-527" data-mp="1alqtexl2lwg8">
      <p data-id="element-528" data-mp="1fir1tf5e7bai">
        {subscriber.companyName} · {subscriber.companyNmls} · {subscriber.licensing}
        {subscriber.equalHousing && ' · Equal Housing Opportunity'}
      </p>
      <p className="mt-1" data-id="element-529" data-mp="15mdyrqnyjl33">
        {loanOfficer.name}, {loanOfficer.nmls} · Powered by {platformName}
      </p>
    </footer>;
}